<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex xs12 md5">
      	 <va-card >
            <template #title>
    {{$t('loan-applications')}}
  </template>
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          <form @submit.prevent="onsubmit">

           <va-select
			              class="mb-4"
			              label="Product"
			              v-model="product_id"
                    searchable
			              textBy="product_name"
			              :loading = "loadSelect"
			              :options="loans"
			              key-by="product_id"
                    @input="setSelected"
			            />
          <va-input
              :label="$t('Basic Salary')"
              type="number"
              v-model="formdata.basicPay"
              :error="!!basicPay.length"
              :error-messages="basicsalaryErrors"
             
            />

            <va-input 
              :label="$t('Loan Amount')"
               type="number"         
               v-model="formdata.appliedamount"
               :error="!!appliedamount.length"
               :error-messages="loanAmountErrors"
               
            />

          	
            <va-select
			              class="mb-4"
			              label="Purpose"
			              v-model="purposecode"
                    searchable
			              textBy="code"
			              :loading = "loadpurpose"
                    :error="!!loanpurpose.length"
                    :error-messages="loanpurposeErrors.length"
			              :options="codes"
			              key-by="code"
			            />
       <va-input 
              :label="$t('Total Allowances')"
               type="number"
              v-model="formdata.allowance"           
              :error="!!allowance.length"
              :error-messages="!!allowanceErrors.length"
               @input="grossSalaryQ"
                
            />	
             <va-input               
              :label="$t('Gross Salary')"
               type="number"
              v-model="this.grossSalary"           
              :error="!!grossSalary.length"
              :error-messages="grossSalaryErrors.length"
              :readonly = "true"  
          
            />	

              <va-input
                    :label="$t('period-months')"
                    type="number"
                    v-model="this.RepaymentPeriod"
                    :error="!!grossSalary.length"
                    :error-messages="grossSalaryErrors.length"               
                  />
            <va-input
              :label="$t('interest %')"
              type="number"
              v-model="this.newInterest"
              :readonly = "true"                     
            />

               <va-input
              :label="$t('Total Interest')"
              type="number"
              v-model="this.totalInterest"
              :readonly = "true"   
              v-if="showIterest"                  
            />
           <!-- <va-input 
              
              :label="$t('Monthly Repayment')"
              type="number"
              v-model="this.payment_amount"           
              :error="!!montlyrepayment.length"
              :error-messages="montlyrepaymentErrors"
            /> -->
            
            
        	 	<div class="row mt-6"> 
              <va-button
              
              type="button"
              @click="getschedule"> 
                Preview Loan Schedule
              </va-button>
              </div>
              <div class="row mt-6"> 
                <va-button type="submit" >
                  {{ $t('forms.controls.submit') }}
                </va-button>                        
            </div>
          </form>
      	 </va-card>
      </div>

      <div class="flex xs12 md12 xl7" v-if="showInfo">
        <template>
          <va-card >
             <template #title>
    {{$t('Loan Schedule')}}
  </template>
                <div class="row align--center mb-1">
                  <div class="flex xs12 sm6">
                    <va-input
                      class="ma-0"
                      :value="term"
                      :placeholder="$t('tables.searchByName')"
                      @input="search"
                      removable
                    >
                      <va-icon name="fa fa-search" slot="prepend" />
                    </va-input>
                  </div>
                </div>

                <va-data-table
                  :fields="mode ? detailedFields : fields"
                  :data="filteredData"
                  :loading="loading"
                  hoverable
                  no-pagination
                >
                  <template v-slot:installment_no="props">
                    {{ props.rowData.installment_no }}
                  </template>
                  <template v-slot:date="props">
                    {{ props.rowData.date | formatDate }}, 20{{props.rowData.repayment_year }}
                  </template>
                  <template v-slot:payment_amount="props">
                    <div style="text-align: right;">{{ props.rowData.payment_amount | Currency }}</div>
                  </template>
                  <template v-slot:interest="props">
                    <div style="text-align: right;">{{ props.rowData.interest | Currency }}</div>
                  </template>
                  <template v-slot:principle="props">
                    <div style="text-align: right;">{{ props.rowData.principle | Currency }}</div>
                  </template>
                  <template v-slot:loan_balance="props">
                    <div style="text-align: right;">{{ props.rowData.loan_balance | Currency }}</div>
                  </template>
                </va-data-table>
              </va-card>        
        </template>
      </div>
    </div>

  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      loadSelect:false,
      loadpurpose:false,
      processingError: false,
      payment_method : '',
      newInterest:'',
      totalInterest:'',
      date:'',
      finalPost : '',
      formdata:{
      	payment_mode:'',
        phone_no:'',
        basicPay:'',
        RepaymentPeriod:'',
     
        appliedamount:'',
        loanpurpose:'',
        repaymentperiod:'',
        grossSalary:'',
      
        user: '',
         allowance:'',
          montlyrepayment:'',
      },
      basicsalaryErrors : [],
      allowanceErrors : [],
      grossSalaryErrors: [],
      loanpurposeErrors: [],
      repaymentperiodErrors: [],
      loanAmountErrors: [],
      montlyrepaymentErrors: [],
      showMpesa : false,
      showFosa: false,
      showInfo:false,
      showIterest:false,
      schedule:{},
      showConfirmModal : false, 
      accname: '',
      RepaymentPeriod:'',
      date:'',
      loanType:'',
      purposecode: '',
      charge:'',
      basicPay:'',
      appliedamount:'',
      repaymentperiod:'',
      loanpurpose:'',
      allowance:'',
      grossSalary:'',
      
      totalloanrepayment:'',
      Totalinterest:'',
      amountErrors : [],
      montlyrepayment:'',
      loans: [
        {
          product_id: '',
          product_name: 'select an Option',
        }],
        codes: [
        {
          purposecode:'',
          
        },
       
      ],
      product_id:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
//      grossSalary(){
//         //console.log(input);
//         //console.log(parseInt(this.formdata.basicsalary) - parseInt(this.formdata.allawances));
// return  parseInt(this.formdata.basicsalary) - parseInt(this.formdata.allawances);
//     },
fields () {
      return [{
        name: '__slot:installment_no',
        title: this.$t('tables.headings.installment_no'),
        sortField: 'installment_no',
      },
      {
        name: '__slot:date',
        title: this.$t('tables.headings.date'),       
        sortField: 'date',
      }, 
      {
        name: '__slot:payment_amount',
        title: this.$t('tables.headings.payment_amount'),       
        sortField: 'payment_amount',
      }, 
      {
        name: '__slot:interest',
        title: this.$t('tables.headings.interest'),       
        sortField: 'interest',
      },
      {
        name: '__slot:principle',
        title: this.$t('tables.headings.principle'),       
        sortField: 'principle',
      },
      {
        name: '__slot:loan_balance',
        title: this.$t('tables.headings.loan_balance'),       
        sortField: 'loan_balance',
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.schedule
      }
      return this.schedule.filter(item => {
        return item.date.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {
      return !this.basicsalaryErrors.length && !this.allowanceErrors.length && !this.montlyrepaymentErrors.length
      && !this.loanAmountErrors.length && !this.amountErrors.length && !this.repaymentperiodErrors.length && !this.loanAmountErrors.length && !this.grossSalaryErrors.length
    }, 
         
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.product_id.toLowerCase() === this.id.toLowerCase());      
    },
    GetPurpose(id) {      
      return this.codes.filter(item => item.purposecode.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit (e) {
      e.preventDefault();
      this.processingError = false;
      this.basicsalaryErrors = this.formdata.amount ? [] : ['Basic Salary is required']
      this.allowanceErrors = this.formdata.amount ? [] : ['Allowances is required']
      this.loanAmountErrors = this.formdata.amount ? [] : ['Loan ammount is required']
      this.grossSalaryErrors  = this.formdata.amount ? [] : ['Gross Salary is required']
      this.loanpurposeErrors  = this.formdata.amount ? [] : ['Loan purpose is required']  
      this.repaymentperiodErrors  = this.formdata.amount ? [] : ['Repayment Period is required']
      this.montlyrepaymentErrors  = this.formdata.amount ? [] : ['Montly repayment is required']
     
     
     if (this.formReady) {

      } 
    
       const form = {
  user:this.userData.user_id,
  loanType: this.product_id.product_id,
  appliedamount: this.formdata.appliedamount,
  RepaymentPeriod:this.RepaymentPeriod,
  basicPay:this.formdata.basicPay,
  allowance:this.formdata.allowance,
  grosspay:this.grossSalary,
  deductions:0,
  loanpurpose: this.purposecode.code,
        };

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}PortalloanApplication`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					console.log(resp);
					if(resp != ''){              
			          self.showToast(`Loan Processed succefully. Kindly add guarantors to finish the process`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                self.GRequest(resp);
      setTimeout( () =>  self.GRequest(resp), 2500);
      
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
    },
    GRequest(LoanapplicationNo){
      console.log(LoanapplicationNo)
      this.$router.push({name: 'loan-LoansMoreDetails', params: { loan_no:LoanapplicationNo}});

    },

    GetLoanProducts () {
      this.loadSelect = true
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetLoanProducts`, self.userData.user_id, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.loans = res
          console.log(res);
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    GetLoanPurpose () {
      this.loadpurpose = true
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetLoanPurposes`, self.userData.user_id, config)
      .then(function (res) {

          self.loadpurpose = false
          self.loading = false
          res = res.data
          self.codes = res
          console.log(res);
      })
      .catch(function (error) {
          console.log(error)
      })
    },
     setnewendDate(value){
      
      this.RepaymentPeriod = this.$options.filters.DateDiff(this.date, value)
    },
  	setSelected(value){
      this.newInterest = value.interest_rate
  		const val = value.id
      if (val) {
        if (val == 'fosa'){
          this.showFosa = true
          this.showMpesa = false
        } else {
          this.showMpesa = true
          this.showFosa = false
        } 
      }
      this.RepaymentPeriod =  value.repayment_period 
      this.newPeriod =  value.repayment_period 
      
  	},
   CheckingifanapplicationExists(LoanapplicationNo){

const form = {
   user:this.userData.user_id,
   phonenumber: this.userData.mobile_number,
   };
 console.log(this.formdata.amount)

     this.loading = true
    var self = this

    let config = {
      headers: {
        Authorization: this.userData.user_id+' '+this.token
      }
      }

    axios.post(`${this.$apiUrl}CheckapplicationExixtance`, form, config) 
    .then(function (res) {
      self.loading = false					
      const resp = res.data;
      
      if(resp == 'True'){              
            self.showToast(`You already have a pending loan applied. You can Edit this loan and submit`, {
              position: 'bottom-right',
              icon: "fa-check",
              duration: 30000,
            })
            self.LoanLoandetails();
            setTimeout( () => self.LoanLoandetails(), 25000);
          }
 if (resp == 'False'){
  self.GetLoanProducts()   
  self.GetLoanPurpose() 
  self.formdata.phone_no  = self.userData.mobile_number
          }  else{
            self.processingError = true
          }               
    })
    .catch(function (error) {
      console.log(error)
    })

},
LoanLoandetails(){
this.$router.push({name: 'loan-MyAppliedLoans', params: { }});
},
GetloanRepamentDetails(){

        const form = {
          product:this.product_id,
          user_id: this.userData.user_id,  
          amount: this.formdata.appliedamount,
          start_date: this.date,
          period : this.RepaymentPeriod,

        };
       
        this.loading = true
        const self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${self.$apiUrl}GetLoanSchedule`, form, config)
        .then(function (res) {          
            self.loading = false
            self.showtable = true
            self.totalInterest=res.data.totalInterest
            console.log(res.data.totalInterest)
            res = res.data.result          
            self.schedule = res.slice();
            self.formdata.montlyrepayment=res.payment_amount
            self.totalLoanrepayment=res.totalLoanRepayments
        })
        .catch(function (error) {
            console.log(error)
        })   
        
},
getschedule(){
  this.GetloanRepamentDetails();
  this.showInfo= true;
  this.showIterest=true;

},
getDeatils(value){
  this.GetloanRepamentDetails()
  this.montlyrepayment=value.payment_amount
  console.log(this.montlyrepayment)
  //this.Totalinterest=(this.newInterest/12/100)*this.formdata.appliedamount/this.RepaymentPeriod;
  
},
     grossSalaryQ(){
        
        this.grossSalary = (this.formdata.basicPay - this.formdata.allowance)
        //console.log( this.grossSalary);
    },
 getgross(value){
  		const val = value.id
   return this.grossSalary 
  	}
  },
  created () { 
    this.CheckingifanapplicationExists();
  	this.formdata.phone_no  = this.userData.mobile_number
    this.formdata.user  = this.userData.user_id
    this.formdata.paybill_code  = this.accdetails.accname
    this.today  = this.$options.filters.dateToYMD(new Date());
    this.date = this.today 
    if(this.userData.is_registered_mobile_user !=  1) {
      var id = 'fosa'
      this.PaymentOptions = this.PaymentOptions.filter((e)=>e.id !== id )
    }
  }
}
</script>